import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
const PrivateLayout = () => {
   const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  
    useEffect(() => {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
    }, [theme]);
  
    const toggleTheme = () => {
      setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
    };
  return (
    <div>

      <main>
        <Outlet context={{ theme, toggleTheme }}/>
      </main>
    </div>
  );
};

export default PrivateLayout;
